import { string } from "@src/libs/yup";

export default string()
	.min(10, "Please enter a valid phone number")
	.phone("Phone is invalid")
	.required("Please enter a valid phone number");
